import { render, staticRenderFns } from "./TabEducation.vue?vue&type=template&id=010be767&"
import script from "./TabEducation.vue?vue&type=script&lang=js&"
export * from "./TabEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\customControl\\custom_stage_lv\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('010be767')) {
      api.createRecord('010be767', component.options)
    } else {
      api.reload('010be767', component.options)
    }
    module.hot.accept("./TabEducation.vue?vue&type=template&id=010be767&", function () {
      api.rerender('010be767', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/talentPortrait/components/tabItem/TabEducation.vue"
export default component.exports